import type { SOWOutline } from './ClientOutlineTypes';

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const getLocalToday = (): Date => {
    const now = new Date();
    return new Date( now.getFullYear(), now.getMonth(), now.getDate() );
};

const normalizeToLocalDate = ( value?: string ): Date | null => {
    const trimmed = value?.trim();
    if( !trimmed ) return null;

    if( DATE_ONLY_PATTERN.test( trimmed ) ){
        const [ yearText, monthText, dayText ] = trimmed.split( '-' );
        const year = Number( yearText );
        const month = Number( monthText );
        const day = Number( dayText );
        if( Number.isFinite( year ) && Number.isFinite( month ) && Number.isFinite( day ) ){
            return new Date( year, month - 1, day );
        }
        return null;
    }

    const parsed = new Date( trimmed );
    if( Number.isNaN( parsed.getTime() ) ) return null;

    return new Date( parsed.getFullYear(), parsed.getMonth(), parsed.getDate() );
};

export const isSowActiveForDate = ( sow: SOWOutline, today: Date ): boolean => {
    const start = normalizeToLocalDate( sow.StartDate );
    const end = normalizeToLocalDate( sow.EndDate );

    if( start && end ) return start <= today && today <= end;
    if( start ) return start <= today;
    if( end ) return today <= end;

    return false;
};

export const formatSowDate = ( value?: string ): string => {
    if( !value ) return 'Not set';

    const trimmed = value.trim();
    if( !trimmed ) return 'Not set';

    const dateOnly = trimmed.split( 'T' )[ 0 ];
    const [ year, month, day ] = dateOnly.split( '-' ).map( Number );
    if( !year || !month || !day ) return trimmed;

    const date = new Date( Date.UTC( year, month - 1, day ) );
    return date.toLocaleDateString();
};

export const formatSowDateRange = ( sow: SOWOutline ): string => {
    const hasAnyDate = !!( sow.StartDate?.trim() || sow.EndDate?.trim() );
    return hasAnyDate
        ? `${ formatSowDate( sow.StartDate ) } \u2013 ${ formatSowDate( sow.EndDate ) }`
        : 'No date set';
};

// Prefer the first active SOW so the page opens on current work.
export const pickDefaultSow = ( sows: SOWOutline[], today: Date ): SOWOutline | undefined =>
    sows.find( sow => isSowActiveForDate( sow, today ) ) ?? sows[ 0 ];
